import { createSlice } from "@reduxjs/toolkit";
import { getChefStatusAPI } from "../../api/chef";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
}; 

const getChefStatusSlice = createSlice({
  name: "getChefStatus",
  initialState: data,
  reducers: {
   getChefStatusSlice(state) {
      state.isLoading = true;
    },
   getChefStatusSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    getChefStatusSliceFailure(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
   getChefStatusSliceReset(state) {
      state.isLoading = false;
      state.data = null;
    },
  },
});
export const getChefStatusHandler = (data:any) => async (dispatch: any) => {
  try {
    dispatch(getChefStatusAction.getChefStatusSlice());
    const response: any = await getChefStatusAPI(data);
    
    dispatch(getChefStatusAction.getChefStatusSliceSuccess(response));
  } catch (e: any) {
    dispatch(getChefStatusAction.getChefStatusSliceFailure(e?.response?.data));
  }
};
export default getChefStatusSlice.reducer;
export const getChefStatusAction = getChefStatusSlice.actions;
